var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"song",attrs:{"id":"Song"}},[_c('v-card',[_c('v-card-title',{staticClass:"justify-center"},[_vm._v(_vm._s(_vm.song.artist)+" - "+_vm._s(_vm.song.songName)+" ")]),_c('v-card-text',[_c('pre',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.song.textContent))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }